import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const inputVariants = cva("h-input", {
  variants: {
    size: {
      sm: "h-input--sm",
      xs: "h-input--xs",
      lg: "h-input--lg",
    },
    fullWidth: {
      true: "h-input--block",
    },
  },
})

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input"> & VariantProps<typeof inputVariants>
>(({ className, type, size, fullWidth, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(inputVariants({ size, fullWidth, className }), className)}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }
